'use client';

import { Clock3, Lightbulb } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';
import dayjs from 'dayjs';

interface MessageRiskProps {
  riskStatement?: string;
  createdAt?: string | Date;
}
export default function MessageRisk({ riskStatement, createdAt }: MessageRiskProps) {
  const { t } = useTranslation();

  return (
    <div className="text-sm text-[#757575] mt-[30px] pb-5 border-b dark:border-[#1E1E1E] border-[#EFEFEF] leading-6">
      {riskStatement && (
        <p className="flex items-center gap-2">
          <Lightbulb size={16} />
          {t(riskStatement)}
        </p>
      )}
      {createdAt && (
        <p className="flex items-center gap-2">
          <Clock3 size={14} />
          {t('Generated on:')} {dayjs(createdAt).format('YYYY/MM/DD HH:mm')}
        </p>
      )}
    </div>
  );
}
